import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/styles';
import { Card } from "@material-ui/core";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Page from 'src/components/Page';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  rootCard: {
    maxWidth: 345
  },
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2)
  },
  media: {
    height: 140
    , padding: theme.spacing(6, 2)
  }
}));
function Employee() {
  const classes = useStyles();
  const history = useHistory();
  const [roleTypes, setRoleTypes] = useState(0);
  const [loading, setLoading] = useState(false);
  const SessionUser = getUser();
  useEffect(() => {
    getEmployeeManagementRole();

  }, []);

  const getEmployeeManagementRole = () => {
    setLoading(true);
    axios.get(`GetEmployeeManagementRole`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setRoleTypes(response.data[0]);
        } else {
          setRoleTypes(0);
        }
        setLoading(false);
      });

  }




  return (
    <Page
      className={classes.root}
      title={"Çalışan Yönetimi"}
    >
      <Grid container>
        <Grid item xs={12} xm={12} xl={12}>
          <Grid container spacing={2} >
            {roleTypes.SERVIS_GOREBILIR ?
              <Grid key={1} xs={12} xm={12} md={12}
                component={RouterLink}
                to={`/EmployeeMain/1`}
                item
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Card
                  className={classes.rootCard}>
                  <CardActionArea>
                    <CardMedia
                      className={classes.media}
                      image="https://artemis.arcelik.com/static/media/konsep_2.3941314b.jpg"
                      title="Yetkili Servis"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        Servis Organizasyonu
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        Servis organizasyonu çalışan yönetimi, işletmelerin hizmet
                        sunumunda çalışanları etkin bir şekilde yönlendirmek ve
                        performanslarını iyileştirmek için stratejiler ve yöntemler
                        geliştiren bir süreçtir. Bu süreç, çalışanların eğitimi,
                        takibi, değerlendirilmesi ve motivasyonu gibi unsurları
                        içerir.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              : null}
            {roleTypes.BAYI_GOREBILIR ?
              <Grid key={2} xs={12} xm={12} md={12}
                component={RouterLink}
                to={`/EmployeeMain/2`}
                item style={{ display: "flex", justifyContent: "center" }} >
                <Card className={classes.rootCard}>
                  <CardActionArea>
                    <CardMedia
                      className={classes.media}
                      image="https://www.sadirvanonline.com/images/galleria-umitkoy-arcelik-22.jpg"
                      title="Contemplative Reptile"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        Bayi Organizasyonu
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        Satış bayilerinin organizasyonu çalışan yönetimi,
                        bayi ağının etkin bir şekilde yönetilmesini sağlayan stratejiler ve yöntemler bütünüdür. Bu süreç, bayilerin eğitimi, performans takibi,
                        satış hedeflerinin belirlenmesi ve
                        motivasyonu gibi unsurları içerir. Bayi Çalışan bilgilerini düzenlemeye yardımcı olur.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              : null}

            {roleTypes.BAYI_GOREBILIR === false && roleTypes.SERVIS_GOREBILIR === false ?
              <Grid key={2} xs={12} xm={12} md={12}
                item style={{ display: "flex", justifyContent: "center" }} >
                <Card className={classes.rootCard}>
                  <CardActionArea>
                    <CardMedia
                      className={classes.media}
                      image="https://www.sadirvanonline.com/images/galleria-umitkoy-arcelik-22.jpg"
                      title="Contemplative Reptile"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                       Yetki Yönetimi
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        Sistemde Bayi ve Servis Organizasyonunu görmeye yetkili değilsiniz!...
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              : null}
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
}

export default Employee;
